<template>
	<div>
		<div style=" width:1141px;margin:auto">
			<div
				style="font-size:18px;font-weight: 700;text-align: left; height:50px;line-height: 70px; border-bottom: 2px solid #ccc;">
				个人中心</div>
			<div style="height:50px;display: flex;flex-direction: row; justify-content: flex-start;margin:8px 0;">
				<div class="block" style=" height:50px;line-height: 50px;float:left;">
					<el-avatar :size="50" :src="circleUrl"></el-avatar>
				</div>
				<div style="height:50px;line-height: 50px;float:left;margin-left:20px;">账号：{{username}}</div>
				<div style="height:50px;line-height: 50px;float:left;margin-left:20px;"><i class="el-icon-headset"></i>
					官方客服</div>
			</div>
			<div style="margin:8px 0; padding: 4px;">
				<el-card class="box-card" style="margin-bottom:10px;" v-show="disphzyx">
					<div style="border-bottom: 2px solid #ccc;text-align: left;height:40px;line-height:40px;">
						<div style="font-size:20x;font-weight: 700;"> 合作意向</div>
					</div>
					<div
						style="display: flex;flex-direction: row;justify-content:flex-start;margin:8px 0; padding: 4px;">
						<template>
							<el-table stripe
								:header-cell-style="{'text-align':'center','background-color':'#FF7F50','color':'#333'}"
								:data="tableData" size="mini" border style="width: 100%">
								<el-table-column prop="HZFS" label="合作方式" width="100">
								</el-table-column>
								<el-table-column prop="HZYX" label="合作意向">
									<div slot-scope="scope">
										<div :type="scope.row.HZYX">
											<span v-if="scope.row.HZYX.length<20">
												{{scope.row.HZYX}}
											</span>
											<div v-else>
												<el-popover placement="top-start" width="300" trigger="hover" style=""
													:content="scope.row.HZYX">
													<span slot="reference" class="mypop">
														{{
															scope.row.HZYX.substring(0,20)+"..."
														}}
													</span>
												</el-popover>
											</div>
										</div>
									</div>
								</el-table-column>
								<el-table-column prop="OPRTTIME" label="提交日期" width="140" align="center">
									<template slot-scope="scope">
										{{ scope.row.OPRTTIME | formatter('yyyy-MM-dd hh:mm:ss') }}
									</template>
								</el-table-column>
								<el-table-column prop="DFNR" label="答复内容">
									<div slot-scope="scope">
										<div :type="scope.row.DFNR">
											<span v-if="scope.row.HZYX.length<20">
												{{scope.row.DFNR}}
											</span>
											<div v-else>
												<el-popover placement="top-start" width="300" trigger="hover" style=""
													:content="scope.row.DFNR">
													<span slot="reference" class="mypop">
														{{
															scope.row.DFNR.substring(0,20)+"..."
														}}
													</span>
												</el-popover>
											</div>
										</div>
									</div>
								</el-table-column>
								<el-table-column prop="DFTIME" label="答复日期" width="140" align="center">
									<template slot-scope="scope">
										{{ scope.row.DFTIME | formatter('yyyy-MM-dd hh:mm:ss') }}
									</template>
								</el-table-column>
							</el-table>
						</template>
					</div>
				</el-card>
				<el-card class="box-card" style="margin-bottom:10px;">
					<div style="border-bottom: 2px solid #ccc;text-align: left;height:40px;line-height:40px;">
						<div style="font-size:20x;font-weight: 700;"> 我的交易</div>
					</div>
					<div
						style="display: flex;flex-direction: row;justify-content:flex-start;margin:8px 0; padding: 4px;">
						<div style="margin-right:20px;cursor:pointer"><i class="el-icon-bank-card"></i> 待付款</div>
						<div style="margin-right:20px;cursor:pointer"><i class="el-icon-box"></i> 待发货</div>
						<div style="margin-right:20px;cursor:pointer"><i class="el-icon-circle-check"></i> 待确认</div>
						<div style="margin-right:20px;cursor:pointer"><i class="el-icon-lock "></i> 已完成</div>
					</div>
				</el-card>
				<el-card class="box-card" style="margin-bottom:10px;">
					<div style="border-bottom: 2px solid #ccc;text-align: left;height:40px;line-height:40px;">
						<div style="font-size:20x;font-weight: 700;"> 我的权益</div>
					</div>
					<div
						style="display: flex;flex-direction: row;justify-content:flex-start;margin:8px 0; padding: 4px;">
						<div style="margin-right:20px;cursor:pointer"><i class="el-icon-bank-card"></i> 卡券:
							{{ myCardNum }} 张
						</div>
						<div style="margin-right:20px;cursor:pointer"><i class="el-icon-box"></i> 积分: {{ myIntegral }} 分
						</div>
					</div>
				</el-card>
				<el-card class="box-card" style="margin-bottom:10px;">
					<div class="myPanel">
						<div class="myPanelItem"
							:style="{backgroundImage: 'url('+require('../../assets/Personal/it1.png')+')'}">
							热销产品
						</div>
						<div class="myPanelItem"
							:style="{backgroundImage: 'url('+require('../../assets/Personal/it2.png')+')'}">
							特种商品
						</div>
						<div class="myPanelItem"
							:style="{backgroundImage: 'url('+require('../../assets/Personal/it3.png')+')'}">
							最新上架
						</div>
						<div class="myPanelItem"
							:style="{backgroundImage: 'url('+require('../../assets/Personal/it4.png')+')'}">
							火热预订
						</div>
					</div>
				</el-card>
				<div style="display: flex;flex-direction: row; flex-wrap: wrap; justify-content:space-around;">
					<el-card :body-style="{ padding: '0px'}" style="margin:10px">
						<img style="width:200px;height:200px;" src="../../assets/Personal/it1.png" class="image">
						<div style="padding: 4px;">
							<span>冷轧</span>
							<div class="bottom clearfix">
								<el-button type="text" class="button">详情>></el-button>
							</div>
						</div>
					</el-card>
					<el-card :body-style="{ padding: '0px' }" style="margin:10px">
						<img style="width:200px;height:200px;" src="../../assets/Personal/it2.png" class="image">
						<div style="padding: 4px;">
							<span>无缝</span>
							<div class="bottom clearfix">
								<el-button type="text" class="button">详情>></el-button>
							</div>
						</div>
					</el-card>
					<el-card :body-style="{ padding: '0px'}" style="margin:10px">
						<img style="width:200px;height:200px;" src="../../assets/Personal/it3.png" class="image">
						<div style="padding: 4px;">
							<span>酸洗</span>
							<div class="bottom clearfix">
								<el-button type="text" class="button">详情>></el-button>
							</div>
						</div>
					</el-card>
					<el-card :body-style="{ padding: '0px'}" style="margin:10px">
						<img style="width:200px;height:200px;" src="../../assets/Personal/it4.png" class="image">
						<div style="padding: 4px;">
							<span>定制</span>
							<div class="bottom clearfix">
								<el-button type="text" class="button">详情>></el-button>
							</div>
						</div>
					</el-card>
					<el-card :body-style="{ padding: '0px'}" style="margin:10px">
						<img style="width:200px;height:200px;" src="../../assets/Personal/it5.png" class="image">
						<div style="padding: 4px;">
							<span>钢柱</span>
							<div class="bottom clearfix">
								<el-button type="text" class="button">详情>></el-button>
							</div>
						</div>
					</el-card>
					<el-card :body-style="{ padding: '0px'}" style="margin:10px">
						<img style="width:200px;height:200px;" src="../../assets/Personal/it6.png" class="image">
						<div style="padding: 4px;">
							<span>钢轨</span>
							<div class="bottom clearfix">
								<el-button type="text" class="button">详情>></el-button>
							</div>
						</div>
					</el-card>
					<el-card :body-style="{ padding: '0px'}" style="margin:10px">
						<img style="width:200px;height:200px;" src="../../assets/Personal/it7.png" class="image">
						<div style="padding: 4px;">
							<span>不锈钢</span>
							<div class="bottom clearfix">
								<el-button type="text" class="button">详情>></el-button>
							</div>
						</div>
					</el-card>
					<el-card :body-style="{ padding: '0px'}" style="margin:10px">
						<img style="width:200px;height:200px;" src="../../assets/Personal/it8.png" class="image">
						<div style="padding: 4px;">
							<span>钢卷</span>
							<div class="bottom clearfix">
								<el-button type="text" class="button">详情>></el-button>
							</div>
						</div>
					</el-card>
					<el-card :body-style="{ padding: '0px'}" style="margin:10px">
						<img style="width:200px;height:200px;" src="../../assets/Personal/it9.png" class="image">
						<div style="padding: 4px;">
							<span>不锈钢棍</span>
							<div class="bottom clearfix">
								<el-button type="text" class="button">详情>></el-button>
							</div>
						</div>
					</el-card>
					<el-card :body-style="{ padding: '0px'}" style="margin:10px">
						<img style="width:200px;height:200px;" src="../../assets/Personal/it10.png" class="image">
						<div style="padding: 4px;">
							<span>冶炼</span>
							<div class="bottom clearfix">
								<el-button type="text" class="button">详情>></el-button>
							</div>
						</div>
					</el-card>
				</div>
			</div>
		</div>
		<div
			style="width:100%;background-color: #efefef;text-align: center; height: 50px;line-height: 50px;border-bottom: 1px solid #ccc; margin-bottom: 8px;">
			2022 重庆市离离科技有限公司 备案 渝ICP备2020011628号-1
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				circleUrl: require("../../assets/Personal/avatar.png"),
				myCardNum: 0,
				myIntegral: 0,
				disphzyx: false,
				tableData: [],
				username: '',
				custid: ''
			}
		},
		created() {
			this.getHZYX()
			this.custid = JSON.parse(localStorage.getItem('userInfo')).CUSTID
			this.username = JSON.parse(localStorage.getItem('userInfo')).CUSTNAME
		},
		methods: {
			getHZYX() {
				let self = this
				let url = 'http://www.liligc.com/NWCenter/dlCustTest'
				self.axios.get(url, {
					params: {
						action: 'HZYXByCustId',
						custid: self.custid
					}

				}).then(function(res) {
					if (res.data.result) {
						self.disphzyx = true
						self.tableData = res.data.ja
					} else {
						this.$message.error('服务部可用');
					}
				}).catch(function(err) {
					this.$message.error(err);
				});
			}
		}
	}
</script>

<style lang="less" scoped>
	.myPanel {
		padding: 4px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
	}

	.mypop {
		text-decoration: underline;
		color: #6495ED;
		text-underline-offset: 0.3em;
		cursor: pointer;
	}

	.myPanelItem {
		background-position: center;
		width: 140px;
		height: 140px;
		border: 1px solid #ccc;
		border-radius: 70px;
		margin-right: 20px;
		text-align: center;
		line-height: 140px;
		color: white;
		font-size: 18px;
		text-shadow: 5px 5px 5px #ebebeb;
		transition: width 2s, height 2s, transform 2s; //效果1
	}

	.myPanelItem:hover {
		color: red;
		cursor: pointer;
		font-size: 22px;
		font-weight: 700;
		transform: rotate(360deg); //效果1
	}
</style>
